import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  src: "/fonts/Roboto-Regular.ttf",
  fontWeight: "normal",
  fontStyle: "normal",
  fonts: [
    {
      src: "/fonts/Roboto-Bold.ttf",
      fontWeight: "bold",
      fontStyle: "normal",
    },
  ],
});

Font.register({
  family: "Oswald",
  src: "/fonts/Oswald-Regular.ttf",
  fontWeight: "normal",
  fontStyle: "normal",
  fonts: [
    {
      src: "/fonts/Oswald-Bold.ttf",
      fontWeight: "bold",
      fontStyle: "normal",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    gap: 10,
    backgroundColor: "#fff",
    fontFamily: "Roboto",
    padding: 10,
  },
  section: {
    flexDirection: "column",
    gap: 10,
    justifyContent: "center",
    alignItems: "center",
    margin: 10,
    padding: 10,
  },
  titleText: {
    fontFamily: "Oswald",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 20,
  },
  subtitleText: {
    fontFamily: "Roboto",
    textAlign: "center",
    fontWeight: "normal",
    fontSize: 12,
  },
  normalText: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: "normal",
    textAlign: "left",
  },
  tableView: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: 5,
    overflow: "hidden",
  },
  tableHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    backgroundColor: "#ccc",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: "normal",
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
});

export default function VendasCardapioPDF({
  data,
  dataInicial,
  dataFinal,
  cardapios,
  selectedMenu,
}) {
  const cardapioSelecionado = cardapios.find(
    (cardapio) => cardapio.value === selectedMenu
  );

  return (
    <Document
      creationDate={new Date()}
      author="Santa Ficha"
      title={`Vendas por Cardápio - ${new Date().toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })}`}
      subject="Vendas por Cardápio"
      keywords="relatório, vendas, cardápio, santa ficha"
      producer="Santa Ficha"
      creator="Santa Ficha"
      language="pt-BR"
    >
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.titleText}>Vendas por Cardápio</Text>

          <Text style={styles.subtitleText}>
            De{" "}
            {new Date(dataInicial).toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })}{" "}
            | até{" "}
            {new Date(dataFinal).toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Text>
        </View>
        {data.map((item, index) => (
          <View key={index} style={styles.section}>
            <Text style={styles.titleText}>
              {Object.keys(cardapioSelecionado).length > 0
                ? cardapioSelecionado.label
                : "Sem Cardápio"}
            </Text>

            <View style={styles.tableView}>
              <View style={styles.tableHeader}>
                <Text style={{ width: "30%" }}>Produto </Text>
                <Text style={{ width: "15%", textAlign: "right" }}>
                  Quantidade
                </Text>
                <Text style={{ width: "15%", textAlign: "right" }}>
                  Comissão
                </Text>
                <Text style={{ width: "30%", textAlign: "right" }}>Total</Text>
              </View>
              {item?.vendas.map((row, index) => (
                <View style={styles.tableRow} key={index}>
                  <Text style={{ width: "30%" }}>
                    {row?.CODIGO} - {row?.DESCRICAO}
                  </Text>
                  <Text style={{ width: "15%", textAlign: "right" }}>
                    {row?.QTDE}
                  </Text>
                  <Text style={{ width: "15%", textAlign: "right" }}>
                    {Number(row?.COMISSAO).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </Text>
                  <Text style={{ width: "30%", textAlign: "right" }}>
                    {Number(row?.TOTAL).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </Text>
                </View>
              ))}
              <View style={styles.tableHeader}>
                <Text style={{ width: "30%" }}>Total</Text>
                <Text style={{ width: "15%", textAlign: "right" }}>
                  {item?.totais?.qtde}
                </Text>
                <Text style={{ width: "15%", textAlign: "right" }}>
                  {Number(item?.totais?.comissao).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Text>
                <Text style={{ width: "30%", textAlign: "right" }}>
                  {Number(item?.totais?.total).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Text>
              </View>
            </View>
          </View>
        ))}
      </Page>
    </Document>
  );
}
